// extracted by mini-css-extract-plugin
export default {"label":"Uploader_label__+7Oea","description":"Uploader_description__Gsj09","icon":"Uploader_icon__Y95cr"};